module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//4.jpg?baff487bf4ccf398be26dd4fa2bcec44";